import { render, staticRenderFns } from "./twitterTopic.vue?vue&type=template&id=47a739de"
import script from "./twitterTopic.vue?vue&type=script&lang=js"
export * from "./twitterTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports